module.exports = __webpack_public_path__ + "img/explain_radio.8788c5c4.svg";